import type { GuestsState } from './types';

export const initialState: GuestsState = {
  authToken: null,
  id: null,
};

export default (state = initialState): GuestsState => state;
